// * 공통 라우트

const cmmnRoutes = [
  {
    path: "/:pathMatch(.*)*",
    name: "NotFound",
    meta: {
      auth: false,
      noCrumb: true,
    },
    component: () => import("@/views/common/ErrorPage.vue"),
  },
  {
    name: "error",
    path: "/error",
    meta: {
      auth: false,
      noCrumb: true,
    },
    component: () => import("@/views/common/ErrorPage.vue"),
  },
  {
    name: "noServer",
    path: "/noServer",
    meta: {
      auth: false,
      noCrumb: true,
    },
    component: () => import("@/views/common/NoPage.vue"),
  },
];

export default cmmnRoutes;
